import {Injectable} from '@angular/core';
import {
  HTTP_INTERCEPTORS, HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable, throwError as observableThrowError} from 'rxjs';
import {catchError} from "rxjs/operators";
import {TokenService} from "../../service/token.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }

    const token = this.tokenService.getToken();
    if (token === null) {
      return next.handle(req);
    }

    const httpHeaders: HttpHeaders = req.headers
      .set('Authorization', 'Bearer ' + token);

    const cloned = req.clone({
      headers: httpHeaders
    });

    return next.handle(cloned).pipe(
      catchError(err => {
        if (err.status === 401 || err.status === 403) {
          this.router.navigate(['/logout']);
        }
        return observableThrowError(err);
      })
    );
  }
}

export const AUTH_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true
};
